import { useMemo } from 'react'
import { useGetConsentforms } from '@/api/generated/consent-form/consent-form'

/**
 * Shared consent-form read.
 *
 * Replaces the `getServicesTypesAdditionalConsentForms` thunk and the
 * `newService.additionalConsentFormsOptions` selector that both new-service and view-service
 * consumed. Both pages now read from one React Query cache. Returns the list under
 * `additionalConsentFormsOptions` to match the field the consuming forms expect.
 */
export const useConsentForms = () => {
  const query = useGetConsentforms()
  const additionalConsentFormsOptions = useMemo(() => query.data ?? [], [query.data])

  return { ...query, additionalConsentFormsOptions }
}
